module.exports = __webpack_public_path__ + "krecove-zily_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_1_after.jpg
// module id = 1025
// module chunks = 0